// extracted by mini-css-extract-plugin
module.exports = {"BLOCK":"AnalyticsButton_BLOCK__10BI0","icon":"AnalyticsButton_icon__2GCMU"};